import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["filter", "selectAll"];

  connect() {
    $(".dropdown", this.element).on("hide.bs.dropdown", function(event) {
      if(event.clickEvent) event.preventDefault();
    });

    $(window).on("click.submission-reviews-dropdown-close", (event) => {
      var openDropdown = $(".dropdown-menu.show")[0];
      if(!openDropdown) return;

      if($(openDropdown).is(event.target) || $.contains(openDropdown, event.target)) return;

      $(openDropdown).closest(".dropdown").find(".dropdown-toggle").dropdown("toggle");
    })

    $(this.filterTarget).on("change", "input, select, textarea", (event) => {
      // Bootstrap has a bug with button toggle groups where the individual buttons are for checkboxes
      // In this scenario, the change event on the input will be fired twice; filter out one of the duplicate events
      if(!event.originalEvent && $(event.target).is(".btn-group-toggle :checkbox")) return;
      this.search(event);
    });

    var ENGAGEMENT_TOTALS_RANGE_MAP = [0, 100, 1000, 10000, 100000, 1000000];

    $("#engagement_total").on("input", function() {
      $("#engagement_display").text(ENGAGEMENT_TOTALS_RANGE_MAP[$(this).val()]);
    }).trigger("input");
  }

  disconnect() {
    $(".dropdown", this.element).off("hide.bs.dropdown");
    $(this.filterTarget).off("change");
    $(window).off("click.submission-reviews-dropdown-close");
  }

  approve(event) {
    event.preventDefault();
    this.update(event, "approve");
  }
  
  reject(event) {
    event.preventDefault();
    this.update(event, "reject");
  }

  rejectAsSpam(event) {
    event.preventDefault();
    this.update(event, "reject_as_spam");
  }

  lowPriority(event) {
    event.preventDefault();
    this.update(event, "low_priority");
  }

  normalPriority(event) {
    event.preventDefault();
    this.update(event, "normal_priority");
  }

  highPriority(event) {
    event.preventDefault();
    this.update(event, "high_priority");
  }

  beforeUpdate() {
    $("button", this.element).attr("disabled", true);

    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterUpdate() {
    this.selectAllTarget.checked = false;
    $("button", this.element).removeAttr("disabled");
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  search(event) {
    this.beforeUpdate();
    const params = new URLSearchParams(window.location.search)
    params.delete('platforms[]')
    params.delete('review_priority')
    params.delete('media_types[]')

    var url = this.data.get("url") + "?" + $("input, select, textarea", $(this.filterTarget)).serialize() + '&' + params.toString();
    history.pushState({ turbolinks: true, url: url }, "", url);

    $.get(url, (data) => {
      $("#submission-reviews-results").replaceWith($(data).find("#submission-reviews-results"));
      this.afterUpdate();
    });
  }

  update(event, action) {
    if(!$("input[name='ids[]']:checked", this.element).length) return;

    this.beforeUpdate();

    var params = $("input, select, textarea", this.element).serializeArray();
    params.push({ name: "update_action", value: action });

    $.ajax(this.data.get("updateUrl"), {
      method: "POST",
      data: params,
      success: (data, status) => {
        if(data != null) {
          //error case
          this.afterUpdate();
        }
        else {
          this.afterUpdate();
          this.search();
        }
      }
    });
  }

  addTranslationField(event) {
    var submission_id = $(event.target).data("id")
    $(`#text-area-${submission_id}`).html(
      `<textarea id='translation-text-${submission_id}' class='mt-2' rows='5' cols='30'></textarea>` +
      `<button type='button' class='btn btn-success btn-sm' data-action='submission-reviews#updateTranslation' data-id='${submission_id}'>Update</button>`
    )
  }

  updateTranslation(event){
    var submission_id = $(event.target).data("id")
    var text = $(`#translation-text-${submission_id}`).val()
    $.ajax(`/submissions/${submission_id}.json`, {
      method: "PATCH",
      data: {"submission": {"content_translation": text}, "is_reviews_page": true},
      success: (data, status) => {
        $(`#content-translation-${submission_id}`).text(text)
        $(`#text-area-${submission_id}`).html("")
      }
    });

  }

  selectAllChecked(event) {
    $("input[name='ids[]']", this.element).prop("checked", this.selectAllTarget.checked);
    event.stopPropagation();
  }

  checked() {
    this.selectAllTarget.checked = $("input[name='ids[]']", this.element).not(":checked").length == 0;
  }

  searchQuery(event) {
    let url = new URL(window.location.href);
    var keyword = $("#q").val();
    url.searchParams.set('q', keyword)
    if(keyword == null || keyword == '') { url.searchParams.delete("q") };
    window.location.href = url.href;
  }
}
